<template>
    <HasAccess v-if="access" :video="video" :isMasterclass="isMasterclass" />
    <NoAccess v-else :video="video" :isMasterclass="isMasterclass" />
</template>


<script>
    const isMc = (video) => {
        video = video || this.video;

        return video.tags && video.tags.some(tag => {
            return tag.id == '5f2403de44e5cd0355d7deb2';
        });
    };


    export default {
        components: {
            HasAccess: () => import('~/components/videoPage/HasAccess.vue'),
            NoAccess: () => import('~/components/videoPage/NoAccess.vue')
        },

        head () {
            let titleTpl = 'page.video.lectureTitle';
            let url      = `${process.env.baseUrl}/learning/lecture/${this.video.slug || this.video.id}`;

            if (this.isMasterclass) {
                titleTpl = 'page.video.masterclassTitle';
                url      = `${process.env.baseUrl}/learning/masterclass/${this.video.slug || this.video.id}`;
            }

            let title = this.video.metaTitle || this.$t(titleTpl, {
                title: this.video.title
            });
            let desc  = this.video.metaDescription || this.video.description;
            let image = this.video.thumbnail ? `${process.env.CDN}/image/medium/${this.video.thumbnail.name}` : '';

            let meta = [
                { hid: 'title', name: "title", content: title },

                { hid: "og:url",   property: "og:url",   content: url },
                { hid: "og:title", property: "og:title", content: title },
                { hid: "og:image", property: "og:image", content: image },

                { hid: "twitter:url",   name: "twitter:url",   content: url },
                { hid: "twitter:title", name: "twitter:title", content: title },
                { hid: "twitter:image", name: "twitter:image", content: image }
            ];

            if (desc) {
                meta.push({ hid: 'description',         name: 'description',         content: desc });
                meta.push({ hid: "og:description",      property: "og:description",  content: desc });
                meta.push({ hid: "twitter:description", name: "twitter:description", content: desc });
            }

            return {
                title,
                meta
            }
        },

        data () {
            return {
                video: {},
                isModer: false,

                access: false
            }
        },

        async asyncData ({ $axios, route, error, redirect, app, $appStore}) {
            $appStore.$patch({activeApp: 'video'});

            let id   = route.params.slug;
            let data = await $axios.$get(`${$axios.defaults.baseURL}/video/get`, {
                params: { id }
            })
            .catch(e => {
                error({ statusCode: 404, message: 'Відео не знайдено' });
            });

            let video = data && data.video;

            if (!video) return error({ statusCode: 404, message: 'Відео не знайдено' });

            if (video && video.slug && video.slug != id && !video.isTemp) {
                if (isMc(video)) {
                    return redirect(app.localePath(`/learning/masterclass/${video.slug}`));
                }

                return redirect(app.localePath(`/learning/lecture/${video.slug}`));
            }

            // Access
            let dued      = video.due && video.due >= new Date();
            let hasAccess = video.hasAccess;

            return {
                video:   video,
                isModer: data && data.isModer,

                access: hasAccess && !dued
            };
        },

        computed: {
            isMasterclass () {
                return isMc(this.video);
            }
        }
    }
</script>
